module.exports = __webpack_public_path__ + "fonts/CormorantUpright-SemiBold.50a95c6.ttf";